import {Monitor} from '@megaphonenpm/mputils/src/Monitor.js';
import {UpdateWebPollTask} from './UpdateWebPollTask.js';

/**
 * WebPollMonitor reads the specified web poll or prediction, and dispatches a CHANGE event if the
 * web poll or prediction's content or vote results have changed.
 */
export class WebPollMonitor extends Monitor {

  constructor (pollID, dataStore, sceneType) {
    super(UpdateWebPollTask, [pollID, dataStore, sceneType], WebPollMonitor.UPDATE_INTERVAL_DURATION, 'MRTSClient');
  }

  setWebPollInfo (id, sceneType) {
    this.taskArgs[0] = id;
    this.taskArgs[2] = sceneType;
  }
}

WebPollMonitor.UPDATE_INTERVAL_DURATION = 10000;
